import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UserManagementDto } from '../models/user-management.dto';
import { UpdateClinicUserRequest } from '../models/update-clinic-user-request.model';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

  private baseUrl = environment.APP_BASE_URL + '/clinic-portal/user-management';

  constructor(private http: HttpClient) {}

  getClinicUsers(search?: string, role?: string, status?: string): Observable<UserManagementDto[]> {
    const params: Record<string, string> = {};

    if (search) {
      params['search'] = search;
    }

    if (role) {
      params['role'] = role;
    }

    if (status) {
      params['status'] = status;
    }

    return this.http.get<UserManagementDto[]>(this.baseUrl, { params });
  }

  updateClinicUser(userId: string, updateRequest: UpdateClinicUserRequest): Observable<UserManagementDto> {
    return this.http.put<UserManagementDto>(`${this.baseUrl}/${userId}`, updateRequest);
  }

  resetPassword(userId: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/${userId}/reset-password`, {});
  }

  toggleUserStatus(userId: string): Observable<UserManagementDto> {
    return this.http.patch<UserManagementDto>(`${this.baseUrl}/${userId}/toggle-status`, {});
  }
}